import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { linkClick } from '../actions/navigation';
import { Link as RouteLink } from 'react-router';

/**
 *  Component adds upon react-router Link with linkClick action
 *  ... for mixpanel tracking
 **/

class Link extends Component {
    static propTypes = {
        metaTitle: PropTypes.string,

        to: PropTypes.string,
        onClick: PropTypes.func,

        // Dispatchers
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        metaTitle: 'other',
    };

    static contextTypes = {
        router: PropTypes.object,
    };

    constructor(props, context) {
        super(props, context);

        this.oldClick = props.onClick;
        this.onClick = (...args) => {
            if (this.props.metaTitle && this.context.router) {
                this.props.dispatch(
                    linkClick({
                        context: this.props.metaTitle,
                        from: this.context.router.getCurrentLocation().pathname,
                        to: this.props.to,
                    })
                );
            }
            if (this.oldClick) {
                this.oldClick(...args);
            }
        };
    }

    render() {
        const props = Object.assign({}, this.props);
        props.onClick = this.onClick;

        delete props.dispatch;
        delete props.linkClick;
        delete props.metaTitle;

        return (
            <RouteLink {...props} />
        );
    }
}

export default connect()(Link);



/** WEBPACK FOOTER **
 ** /src/shared/components/Link.js
 **/